import { Box, List, useTheme, InputBase } from "@mui/material"
import SHModal from "../../theme/Modal/SHModal"
import Shbutton from "../../theme/buttons/Shbutton"
import { tokens } from "../../../theme";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";
import NumberInput from "../../theme/inputs/NumberInput";
import SelectGroup from "../../theme/Select/SelectGroup";
import { useState } from "react";

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import AddIcon from '@mui/icons-material/Add';
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import { useTranslation } from "react-i18next";

const MConfirmation = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();


    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            confirm(event);
        }
    };

    const confirm = () => {
        props.confirm();
        if (props.ignoreCloseAfterConfirm) {
            return;
        }
        
        props.handleClose();
    }

    return(
        <SHModal
            open={props.open}
            onClose={props.handleClose}
            onKeyDown={handleKeyDown}
        >
            <Box 
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:3,
                    display:"flex",
                    flexDirection:"column",
                    gap:1,
                    maxWidth:500,
                }}>
                <Subheading>{props.data?.title ?? props.title}</Subheading>
                <Text center light>{props.data?.subtitle ?? props.subtitle}</Text>
            </Box>
            {!props.forceNoContent &&
                <Box
                    sx={{
                        background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                        padding:3,
                        borderTopLeftRadius:16,
                        borderTopRightRadius:16,
                        textAlign:"center",
                    }}
                >
                    <Text align="center" sx={{ maxWidth: 500, margin: "0 auto", whiteSpace: "normal", wordBreak: "break-word" }}>
                        {props.content ? props.content : props.forceNoContent ? null : t("are_you_sure")}
                    </Text>
                </Box>
            }
            <Box
                component="footer"
                sx={{
                    
                    display:"block",
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    paddingRight:3,
                    paddingLeft:3,
                    zIndex:1058,
                    position:"relative",
                    paddingTop:2,
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    // hideCancel leaves a single acknowledge button on the right
                    justifyContent: props.hideCancel ? "flex-end" : "space-between",
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                        paddingLeft:0,
                    }
                }}
            >
                
                {!props.hideCancel &&
                <Shbutton 
                    isCancel={true} 
                    className={"always-visible"} 
                    onClick={(e) => {
                        if(props.stopPropagation) {
                            e.stopPropagation();
                        }
                        // onCancel turns the left button into a second choice; closing the modal stays handleClose.
                        (props.onCancel ?? props.handleClose)();
                    }}
                    color="primary" 
                    variant="text" 
                    startIcon={<ArrowRightAltIcon/>}
                >
                    {props.cancelLabel ?? t("cancel")}
                </Shbutton>
                }
                <ButtonGroup version={2}>
                    <Shbutton 
                        className={"group-btn"} 
                        color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                        onClick={(e) => {
                            if(props.stopPropagation) {
                                e.stopPropagation();
                            }
                            confirm();
                        }} variant="contained"
                    >
                        {props.confirmLabel ?? t("confirm")}
                    </Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    )
}

export default MConfirmation;